import React, { PureComponent } from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';

class ListField extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      list: new Array(this.props.fieldsNumber).fill(''),
    };
  }

  componentDidMount() {
    const fullList = this.state.list.map((val, i) => this.props.value[i] || '');
    this.setState({ list: fullList });
  }

  onChange = (event) => {
    const list = [...this.state.list];
    list[event.target.name] = event.target.value;
    this.setState({ list });
    this.props.handleData(list);
  };

  renderList = () => {
    return this.state.list.map((val, i) => (
      <Grid size={{ xs: 12 }} key={i}>
        <TextField
          name={`${i}`}
          placeholder="Bullet point"
          fullWidth
          value={val}
          onChange={this.onChange}
        />
      </Grid>
    ));
  };

  render() {
    return (
      <Grid container spacing={3}>
        {this.renderList()}
      </Grid>
    );
  }
}

export default ListField;
